import { WebVitalsInstrumentation } from "@honeycombio/opentelemetry-web";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { WebTracerProvider, BatchSpanProcessor } from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporterWithXhrFallback } from "~/openTelemetry/OTLPTraceExporterWithXhrFallback";
import { SpanFilteringExporter } from "~/openTelemetry/SpanFilteringExporter";
import { getFileNameWithoutHash } from "~/openTelemetry/getFileNameWithoutHash";
import { onlyWhenAuthenticatedFilter } from "~/openTelemetry/onlyWhenAuthenticatedFilter";
import { BrowserAttributesSpanProcessor } from "~/openTelemetry/processors/BrowserAttributesSpanProcessor";
import { PortalAttributesSpanProcessor } from "~/openTelemetry/processors/PortalAttributesSpanProcessor";
import { portalResource } from "~/openTelemetry/resources/portalResource";
import { resolveApplicationRootUri } from "~/utils/resolveApplicationRootUri";
const applicationRootUri = resolveApplicationRootUri(window.location);
const exporter = new OTLPTraceExporterWithXhrFallback({
    url: `${applicationRootUri}api/otlp/v1/traces`,
});
const provider = new WebTracerProvider({
    resource: portalResource,
    spanProcessors: [new BrowserAttributesSpanProcessor(), new PortalAttributesSpanProcessor(), new BatchSpanProcessor(new SpanFilteringExporter(exporter, [onlyWhenAuthenticatedFilter]))],
});
registerInstrumentations({
    instrumentations: [
        new XMLHttpRequestInstrumentation(),
        new DocumentLoadInstrumentation({
            applyCustomAttributesOnSpan: {
                resourceFetch: (span, resource) => {
                    const name = resource.name; // this represents the full url for the resource
                    const fileNameWithPossibleHash = name.split(applicationRootUri)[1];
                    if (!fileNameWithPossibleHash)
                        return;
                    span.setAttribute("file.name", fileNameWithPossibleHash);
                    // We need to exclude the hash to provide us with a stable name across different builds of Octopus,
                    // so that we can monitor trends on individual files
                    const fileNameWithoutHash = getFileNameWithoutHash(fileNameWithPossibleHash);
                    span.setAttribute("file.name.no_hash", fileNameWithoutHash);
                    span.updateName(`resourceFetch: ${fileNameWithoutHash}`);
                },
            },
        }),
        new WebVitalsInstrumentation({
            inp: {
                includeTimingsAsSpans: true,
            },
        }),
    ],
});
provider.register();
